import { Component, Prop } from 'vue-property-decorator'
import { BirthdayEmployeeInfo } from './types';
import UserCardComponent from '@appbase/components/common/UserCard/UserCardComponent';

@Component({})
export default class BirthdayItem extends UserCardComponent {
  @Prop({ type: Object }) item!: BirthdayEmployeeInfo;
  @Prop({ type: Boolean }) isLoading!: boolean;
}